import { render, staticRenderFns } from "./DistributorBalances.vue?vue&type=template&id=8d8fb1f2&"
import script from "./DistributorBalances.vue?vue&type=script&lang=js&"
export * from "./DistributorBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports